import { defineComponent as _defineComponent } from 'vue'

import AudioControl from '../AudioControl.vue';
import ScreenShareControl from '../ScreenShareControl/Index.vue';
import FullScreenControl from '../FullScreenControl.vue';
import InviteControl from '../InviteControl.vue';
import VideoControl from '../VideoControl.vue';
import ManageMemberControl from '../ManageMemberControl.vue';
import ChatControl from '../ChatControl.vue';
import MasterApplyControl from '../ManageStageControl.vue';
import MemberApplyControl from '../ApplyControl/MemberApplyControl.vue';
import MoreControl from '../MoreControl';
import EndControl from '../EndControl';
import SettingControl from '../SettingControl.vue';
import WhiteboardControl from '../WhiteboardControl.vue';
import VirtualBackground from '../VirtualBackground.vue';
import AIControl from '../AIControl.vue';
import BasicBeauty from '../BasicBeauty.vue';
import bus from '../../../hooks/useMitt';

import useRoomFooter from './useRoomFooterHooks';
import { isElectron } from '../../../utils/environment';

export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  emits: ['show-overlay'],
  setup(__props, { emit }) {

const { roomStore, isMaster, isAdmin, isAudience } = useRoomFooter();

function handleControlClick(name: string) {
  bus.emit('experience-communication', name);
}
function handleShowOverlay(data: { name: string; visible: boolean }) {
  emit('show-overlay', data);
}

return { __sfc: true,roomStore, isMaster, isAdmin, isAudience, emit, handleControlClick, handleShowOverlay, AudioControl, ChatControl, MasterApplyControl, MemberApplyControl, EndControl, WhiteboardControl, VirtualBackground, AIControl, isElectron }
}

})